export interface ISibasiHTTPResponse<T = unknown> {
  message: string;
  result: T;
  error: unknown;
}

export enum HTTPResponseStatus {
  SUCCESS = 'success',
  ERROR = 'error'
}

export interface IHTTPResponseMessage {
  type: HTTPResponseStatus;
  title: string;
  message: string;
}
